import { baseUrl } from "../variables/Variables.js";

export const contactList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/contact-us-list`, settings);

    console.log("Raw API Response:", response);

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching contact list:", error);
    throw error;
  }
};

export const addBanner = async (formData) => {
  const Suser = JSON.parse(localStorage.getItem("user"));
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${Suser.token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: formData, // FormData for multipart/form-data
  };

  try {
    const response = await fetch(`${baseUrl}api/add-banner`, settings);
    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error adding banner:", error);
    return {
      success: false,
      error: "Failed to add banner. Please try again later.",
    };
  }
};

export const fetchBanners = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/home-banner-list`, settings);

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching banners:", error);
    throw error;
  }
};

// Add Tech Patient
export const addTechPatient = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data, // FormData for multipart data
  };

  try {
    const response = await fetch(`${baseUrl}api/add-tech-patient`, settings);

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error adding tech patient:", error);
    throw error;
  }
};

// Fetch Tech Patients List
export const fetchTechPatients = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/tech-patient-list`, settings);

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching tech patients:", error);
    throw error;
  }
};

// Edit Tech Patient
export const editTechPatient = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-tech-patient/${id}`,
      settings
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error editing tech patient:", error);
    throw error;
  }
};

// Update Tech Patient
export const updateTechPatient = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data, // FormData for multipart data
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-tech-patient/${id}`,
      settings
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating tech patient:", error);
    throw error;
  }
};

// Trash Tech Patient
export const trashTechPatient = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-tech-patient/${id}`,
      settings
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error trashing tech patient:", error);
    throw error;
  }
};

// Fetch Corporate List

export const fetchCorporateTpaList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-corporate`, settings);
    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching patient stories:", error);
    throw error;
  }
};

// Edit Corporate TPA List

export const editCorporateTpaList = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-corporate/${id}`,
      settings
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error editing patient story:", error);
    throw error;
  }
};

// Update CorporateTPA List
export const updateCorporateTpaList = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data, // FormData for multipart data
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-corporate/${id}`,
      settings
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating patient story:", error);
    throw error;
  }
};

// Fetch Insurance TPA List
export const fetchInsuranceTpaList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-tpa-insurance`, settings);
    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching patient stories:", error);
    throw error;
  }
};

// Edit InsuranceTpa List
export const editInsuranceTpaList = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-tpa-insurance/${id}`,
      settings
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error editing patient story:", error);
    throw error;
  }
};

// Update TPA Insuarance List
export const updateInsuranceTPAList = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data, // FormData for multipart data
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-tpa-insurance/${id}`,
      settings
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating TPA Insuarance List:", error);
    throw error;
  }
};

// Fetch Patient Stories List
export const fetchPatientStories = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/patient-stories-list`,
      settings
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching patient stories:", error);
    throw error;
  }
};

// Add Patient Story
export const addPatientStory = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data, // FormData for multipart data
  };

  try {
    const response = await fetch(`${baseUrl}api/add-patient-story`, settings);

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error adding patient story:", error);
    throw error;
  }
};

// Edit Patient Story
export const editPatientStory = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-patient-story/${id}`,
      settings
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error editing patient story:", error);
    throw error;
  }
};

// Update Patient Story
export const updatePatientStory = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data, // FormData for multipart data
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-patient-story/${id}`,
      settings
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error updating patient story:", error);
    throw error;
  }
};

// Trash Patient Story
export const trashPatientStory = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-patient-story/${id}`,
      settings
    );

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error trashing patient story:", error);
    throw error;
  }
};

// Fetch Upcoming Events List
export const fetchUpcomingEvents = async () => {
  const token = localStorage.getItem("token"); // Token for authentication
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/upcoming-events-list`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching upcoming events:", error);
    throw error;
  }
};

// Add Upcoming Event
export const addUpcomingEvent = async (eventData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: eventData, // FormData for file uploads if needed
  };

  try {
    const response = await fetch(`${baseUrl}api/add-upcoming-events`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding upcoming event:", error);
    throw error;
  }
};

// Edit Upcoming Event
export const editUpcomingEvent = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-upcoming-events/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error editing upcoming event:", error);
    throw error;
  }
};

// Update Upcoming Event
export const updateUpcomingEvent = async (id, eventData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: eventData, // FormData for file uploads if needed
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-upcoming-events/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating upcoming event:", error);
    throw error;
  }
};

// Trash Upcoming Event
export const trashUpcomingEvent = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-upcoming-events/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error trashing upcoming event:", error);
    throw error;
  }
};

// Fetch Better Info Better Health List
export const fetchBetterInfoHealthList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/better-info-health-list`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching better info health list:", error);
    throw error;
  }
};

// Add Better Info Health
export const addBetterInfoHealth = async (infoData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: infoData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-better-info-health`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding better info health:", error);
    throw error;
  }
};

// Edit Better Info Health
export const editBetterInfoHealth = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-better-info-health/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error editing better info health:", error);
    throw error;
  }
};

// Update Better Info Health
export const updateBetterInfoHealth = async (id, infoData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: infoData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-better-info-health/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating better info health:", error);
    throw error;
  }
};

// Trash Better Info Health
export const trashBetterInfoHealth = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-better-info-health/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error trashing better info health:", error);
    throw error;
  }
};

// Fetch Doctors List
export const fetchDoctorsList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-doctors`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching doctors list:", error);
    throw error;
  }
};

// Add Doctor
export const addDoctor = async (doctorData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: doctorData,
  };

  try {
    const response = await fetch(`${baseUrl}api/add-doctor`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding doctor:", error);
    throw error;
  }
};

// Edit Doctor
export const editDoctor = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/edit-doctor/${id}`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error editing doctor:", error);
    throw error;
  }
};

// updateDoctor Doctor
// export const updateDoctor = async (id) => {
//   const token = localStorage.getItem("token");
//   const settings = {
//     method: "POST",
//     headers: {
//       Authorization: `Bearer ${token}`,
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   };

//   try {
//     const response = await fetch(`${baseUrl}api/update-doctor/${id}`, settings);
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error editing doctor:", error);
//     throw error;
//   }
// };

export const updateDoctor = async (id, formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`, // FIXED
      Accept: "application/json",
    },
    body: formData, // FIXED
  };

  try {
    const response = await fetch(`${baseUrl}api/update-doctor/${id}`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating doctor:", error);
    throw error;
  }
};

// Trash Doctor
export const trashDoctor = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/trash-doctor/${id}`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error trashing doctor:", error);
    throw error;
  }
};

// Fetch fetchSpecialtiesList List
export const fetchSpecialtiesList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-specialities`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching specialities list:", error);
    throw error;
  }
};

// Add Specialty
export const addSpecialty = async (specialtyData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: specialtyData,
  };

  try {
    const response = await fetch(`${baseUrl}api/add-specialties`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error adding specialty:", error);
    throw error;
  }
};

// Edit Specialty
export const editSpecialty = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-specialties/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching specialty for editing:", error);
    throw error;
  }
};

// Update Specialty
export const updateSpecialty = async (id, specialtyData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: specialtyData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-specialties/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating specialty:", error);
    throw error;
  }
};

// Trash Specialty
export const trashSpecialty = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-specialties/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error deleting specialty:", error);
    throw error;
  }
};

// Specialities FAQ -

export const FaqSpecialtiesList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-specialities`, settings);
    const data = await response.json();
    return data?.specialities || []; // ✅ Return array or empty fallback
  } catch (error) {
    console.error("Error fetching specialties:", error);
    return []; // Fallback to empty array
  }
};

export const addSpecialityFaq = async (faqData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: faqData,
  };

  try {
    const response = await fetch(`${baseUrl}api/add-spaciality-faq`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error adding FAQ:", error);
    throw error;
  }
};

export const listSpecialityFaq = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-spaciality-faq`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching FAQ list:", error);
    throw error;
  }
};

export const editSpecialityFaq = async (faqId) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-spaciality-faq/${faqId}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error(`Error editing FAQ ID ${faqId}:`, error);
    throw error;
  }
};

export const updateSpecialityFaq = async (faqId, faqData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: faqData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-spaciality-faq/${faqId}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error(`Error updating FAQ ID ${faqId}:`, error);
    throw error;
  }
};

export const trashSpecialityFaq = async (faqId) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-spaciality-faq/${faqId}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error(`Error trashing FAQ ID ${faqId}:`, error);
    throw error;
  }
};

// --- Procedures ---

export const fetchProceduresList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-procedures`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching procedures list:", error);
    throw error;
  }
};

export const addProcedure = async (procedureData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: procedureData,
  };

  try {
    const response = await fetch(`${baseUrl}api/add-procedure`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error adding procedure:", error);
    throw error;
  }
};

export const editProcedure = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/edit-procedure/${id}`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching procedure for editing:", error);
    throw error;
  }
};

export const updateProcedure = async (id, procedureData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: procedureData,
  };

  try {
    const response = await fetch(`${baseUrl}api/update-procedure/${id}`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error updating procedure:", error);
    throw error;
  }
};

export const trashProcedure = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/trash-procedure/${id}`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error deleting procedure:", error);
    throw error;
  }
};

// --- Procedure FAQs ---

export const addProcedureFaq = async (faqData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: faqData,
  };

  try {
    const response = await fetch(`${baseUrl}api/add-procedure-faq`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error adding procedure FAQ:", error);
    throw error;
  }
};

export const listProcedureFaq = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-procedure-faqs`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching procedure FAQ list:", error);
    throw error;
  }
};

export const editProcedureFaq = async (faqId) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/edit-procedure-faq/${faqId}`, settings);
    return await response.json();
  } catch (error) {
    console.error(`Error editing procedure FAQ ID ${faqId}:`, error);
    throw error;
  }
};

export const updateProcedureFaq = async (faqId, faqData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: faqData,
  };

  try {
    const response = await fetch(`${baseUrl}api/update-procedure-faq/${faqId}`, settings);
    return await response.json();
  } catch (error) {
    console.error(`Error updating procedure FAQ ID ${faqId}:`, error);
    throw error;
  }
};

export const trashProcedureFaq = async (faqId) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/trash-procedure-faq/${faqId}`, settings);
    return await response.json();
  } catch (error) {
    console.error(`Error trashing procedure FAQ ID ${faqId}:`, error);
    throw error;
  }
};

export const fetchProceduresBySpeciality = async (specialityId) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ speciality_id: specialityId }),
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-procedures-by-speciality`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching procedures by speciality:", error);
    throw error;
  }
};

// 1. Fetch About Us Content List
export const fetchAboutUsContentList = async () => {
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-aboutus-content-list`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    const result = await response.json();
    if (result.status === "true") {
      return result.data; // return the single content object directly
    } else {
      throw new Error(result.message || "Failed to fetch content");
    }
  } catch (error) {
    console.error("Error fetching About Us content:", error);
    throw error;
  }
};

// 2. Add About Us Content
export const addAboutUsContent = async (formData) => {
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(
      `${baseUrl}api/add-about-us-content`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: formData, // Don't set Content-Type for FormData
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error adding About Us content:", error);
    throw error;
  }
};

// 3. Edit About Us Content
export const editAboutUsContent = async (id) => {
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(
      `${baseUrl}api/edit-about-us-content/${id}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error editing About Us content:", error);
    throw error;
  }
};

// 4. Update About Us Content
export const updateAboutUsContent = async (id, formData) => {
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(
      `${baseUrl}api/update-about-us-content/${id}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: formData,
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating About Us content:", error);
    throw error;
  }
};

// Fetch Why Choose Raheja List
export const fetchWhyChooseRahejaList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-about-why-choose-raheja`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Why Choose Raheja list:", error);
    throw error;
  }
};

// Add Why Choose Raheja
export const addWhyChooseRaheja = async (rahejaData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: rahejaData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-about-why-choose-raheja`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error adding Why Choose Raheja entry:", error);
    throw error;
  }
};

// Edit Why Choose Raheja
export const editWhyChooseRaheja = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-about-why-choose-raheja/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching Why Choose Raheja for editing:", error);
    throw error;
  }
};

// Update Why Choose Raheja
export const updateWhyChooseRaheja = async (id, rahejaData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: rahejaData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-about-why-choose-raheja/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating Why Choose Raheja entry:", error);
    throw error;
  }
};

// Delete Why Choose Raheja
export const deleteWhyChooseRaheja = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-about-why-choose-raheja/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error deleting Why Choose Raheja entry:", error);
    throw error;
  }
};

// Fetch Why Choose Raheja List
export const fetchAwardsAccoladesList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-about-awards-accolades`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Why Choose Raheja list:", error);
    throw error;
  }
};

// Edit Award or Accolade by ID
export const editAwardsAccolade = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-about-awards-accolades/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching award or accolade details:", error);
    throw error;
  }
};

// Update Award or Accolade
export const updateAwardsAccolade = async (id, formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-about-awards-accolades/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating award or accolade:", error);
    throw error;
  }
};

// Trash/Delete Award or Accolade
export const trashAwardsAccolade = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-about-awards-accolades/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting award or accolade:", error);
    throw error;
  }
};

// Add Awards and Accolades
export const addAwardsAccolades = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData, // FormData includes file and other fields
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-awards-accolades`,
      settings
    );
    const data = await response.json(); // Always parse JSON

    if (!response.ok) {
      // If API response is an error, throw an error to be caught below
      throw new Error(
        data.error || data.message || "Failed to add Awards and Accolades."
      );
    }

    return data; // Return success response
  } catch (error) {
    console.error("Error adding Awards and Accolades:", error);
    throw new Error(error.message || "An unexpected error occurred.");
  }
};

// Fetch Careers Job Listings
export const fetchJobList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-job`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching job list:", error);
    throw error;
  }
};

// Add Career Job
export const addJob = async (jobData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: jobData,
  };

  try {
    const response = await fetch(`${baseUrl}api/create-job`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error adding job:", error);
    throw error;
  }
};

// Edit Career Job (Fetch details by ID)
export const fetchJobDetailsById = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/edit-job/${id}`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching job details:", error);
    throw error;
  }
};

// Update Career Job
export const editJob = async (id, jobData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: jobData,
  };

  try {
    const response = await fetch(`${baseUrl}api/edit-job/${id}`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error updating job:", error);
    throw error;
  }
};

// Update Career Job
export const updateJob = async (id, jobData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: jobData,
  };

  try {
    const response = await fetch(`${baseUrl}api/update-job/${id}`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error updating job:", error);
    throw error;
  }
};

// Trash Career Jobs
export const trashJob = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/trash-job/${id}`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error trashing job:", error);
    throw error;
  }
};

// Add Career at Raheja
export const addCareerAtRaheja = async (careerData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: careerData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-career-at-raheja`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error adding Career at Raheja:", error);
    throw error;
  }
};

// Fetch Career at Raheja List
export const fetchCareerAtRahejaList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-career-at-raheja`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching Career at Raheja list:", error);
    throw error;
  }
};

// Edit Career at Raheja
export const editCareerAtRaheja = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-career-at-raheja/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error editing Career at Raheja:", error);
    throw error;
  }
};

// Update Career at Raheja
export const updateCareerAtRaheja = async (id, careerData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: careerData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-career-at-raheja/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating Career at Raheja:", error);
    throw error;
  }
};

// Trash Career at Raheja
export const trashCareerAtRaheja = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-career-at-raheja/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error trashing Career at Raheja:", error);
    throw error;
  }
};

// Add Contact Info
export const addContactInfo = async (contactData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: contactData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-raheja-contact-info`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error adding contact info:", error);
    throw error;
  }
};

// List Contact Info
export const fetchContactInfoList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-raheja-contact-info`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching contact info list:", error);
    throw error;
  }
};

// Edit Contact Info
export const editContactInfo = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-raheja-contact-info/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error editing contact info:", error);
    throw error;
  }
};

// Update Contact Info
export const updateContactInfo = async (id, contactData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: contactData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-raheja-contact-info/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating contact info:", error);
    throw error;
  }
};

// Trash Contact Info
export const trashContactInfo = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-raheja-contact-info/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error trashing contact info:", error);
    throw error;
  }
};

// Fetch Health Checkup Details List
export const fetchHealthCheckupList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-health-checkup-details`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching health checkup list:", error);
    throw error;
  }
};

// Add Health Checkup
export const addHealthCheckup = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-health-checkup-details`,
      settings
    );
    const data = await response.json();
    return {
      status: response.status,
      ...data,
    };
  } catch (error) {
    console.error("Error adding health checkup:", error);
    throw error;
  }
};

// Edit Health Checkup
export const editHealthCheckup = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-health-checkup-details/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching health checkup details:", error);
    throw error;
  }
};

// Update Health Checkup
export const updateHealthCheckup = async (id, formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-health-checkup-details/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating health checkup:", error);
    throw error;
  }
};

// Trash Health Checkup
export const trashHealthCheckup = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-health-checkup-details/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error trashing health checkup:", error);
    throw error;
  }
};

// Add Health Checkup Package
export const addHealthCheckupPackage = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-health-checkup-package`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error adding health checkup package:", error);
    throw error;
  }
};

// List Health Checkup Package
export const fetchHealthCheckupPackageList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-health-checkup-package`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching health checkup packages:", error);
    throw error;
  }
};

// Edit Health Checkup Package
export const editHealthCheckupPackage = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-health-checkup-package/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching package details for editing:", error);
    throw error;
  }
};

// Update Health Checkup Package
export const updateHealthCheckupPackage = async (id, formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-health-checkup-package/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating health checkup package:", error);
    throw error;
  }
};

// Trash Health Checkup Package
export const trashHealthCheckupPackage = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-health-checkup-package/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error deleting health checkup package:", error);
    throw error;
  }
};

// Add Health Checkup Test Inclusion
export const addHealthCheckupTestInclusion = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-health-checkup-test-inclusion`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error adding Health Checkup Test Inclusion:", error);
    throw error;
  }
};

// List Health Checkup Test Inclusions
export const fetchHealthCheckupTestInclusions = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-health-checkup-test-inclusion`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching Health Checkup Test Inclusions:", error);
    throw error;
  }
};

//List Health CheckUp Test master Details
export const fetchHealthCheckupMasterTest = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-health-checkup-test`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error Fetching Health Checkup Test Master Details:", error);
    throw error;
  }
};

//Fetch health chekup test inclusions list using a master_id

export const fetchHealthCheckupTestInclusion = async (testMasterId) => {
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-health-checkup-test-inclusion?test_master_id=${testMasterId}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );
    return await response.json();
  } catch (error) {
    console.error("Error Fetching Health Checkup Test Inclusions:", error);
    throw error;
  }
};

// Edit Health Checkup Test Inclusion
export const editHealthCheckupTestInclusion = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-health-checkup-test-inclusion/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error editing Health Checkup Test Inclusion:", error);
    throw error;
  }
};

// Update Health Checkup Test Inclusion
export const updateHealthCheckupTestInclusion = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-health-checkup-test-inclusion/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating Health Checkup Test Inclusion:", error);
    throw error;
  }
};

// Trash Health Checkup Test Inclusion
export const trashHealthCheckupTestInclusion = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-health-checkup-test-inclusion/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error trashing Health Checkup Test Inclusion:", error);
    throw error;
  }
};

// Add Academics Overview
export const addAcademicsOverview = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-academics-overview`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error adding Academics Overview:", error);
    throw error;
  }
};

// List Academics Overview
export const fetchAcademicsOverview = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-academics-overview`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching Academics Overview:", error);
    throw error;
  }
};

// Edit Academics Overview
export const editAcademicsOverview = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-academics-overview/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error editing Academics Overview:", error);
    throw error;
  }
};

// Update Academics Overview
export const updateAcademicsOverview = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-academics-overview/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating Academics Overview:", error);
    throw error;
  }
};

// Trash Academics Overview
export const trashAcademicsOverview = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-academics-overview/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error trashing Academics Overview:", error);
    throw error;
  }
};

// Add Academics Program Details
export const addAcademicsProgramDetails = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-academics-program-details`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error adding Academics Program Details:", error);
    throw error;
  }
};

// List Academics Program Details
export const fetchAcademicsProgramDetails = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-academics-program-details`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching Academics Program Details:", error);
    throw error;
  }
};

// Edit Academics Program Details
export const editAcademicsProgramDetails = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-academics-program-details/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error editing Academics Program Details:", error);
    throw error;
  }
};

// Update Academics Program Details
export const updateAcademicsProgramDetails = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-academics-program-details/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating Academics Program Details:", error);
    throw error;
  }
};

// Trash Academics Program Details
export const trashAcademicsProgramDetails = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-academics-program-details/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error trashing Academics Program Details:", error);
    throw error;
  }
};

// Add Banner
export const addBannerCMS = async (bannerData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: bannerData,
  };

  try {
    const response = await fetch(`${baseUrl}api/add-banner`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error adding banner:", error);
    throw error;
  }
};

// Fetch Banners
export const fetchBannersCMS = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-all-banner`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching banners:", error);
    throw error;
  }
};

// Edit Banner
export const editBanner = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-home-banner/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching banner details for editing:", error);
    throw error;
  }
};

// Update Banner
export const updateBanner = async (id, bannerData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: bannerData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-home-banner/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating banner:", error);
    throw error;
  }
};

// Trash Banner
export const trashBanner = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-home-banner/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error deleting banner:", error);
    throw error;
  }
};

// Add Blogs
export const addBlog = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  try {
    const response = await fetch(`${baseUrl}api/add-blog`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error adding blog:", error);
    throw error;
  }
};

// Blogs listing Fetch

export const fetchBlogsCMS = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-blogs`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
};

// Edit Blogs
export const editBlogCMS = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/edit-blogs/${id}`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching blog details:", error);
    throw error;
  }
};

// Update Blogs
export const updateBlogCMS = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: data,
  };

  try {
    const response = await fetch(`${baseUrl}api/update-blog/${id}`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error updating blog:", error);
    throw error;
  }
};

// Trash blogs
export const trashBlogCMS = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/trash-blog/${id}`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error deleting blog:", error);
    throw error;
  }
};

// Add FAQ
export const addFaq = async (faqData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(faqData),
  };

  try {
    const response = await fetch(`${baseUrl}api/add-faq`, settings);

    // ✅ Check if response is valid JSON
    const data = await response.json();

    // ✅ Ensure we only return a success status
    if (response.ok && data?.status === "true") {
      return data; // Success response
    } else {
      throw new Error(data?.message || "Failed to add FAQ.");
    }
  } catch (error) {
    console.error("Error adding FAQ:", error);
    throw error; // Ensure error is thrown for frontend handling
  }
};

// Fetch FAQs
export const fetchFaqList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-faq`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching FAQ list:", error);
    throw error;
  }
};

// Edit FAQ
export const editFaq = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/edit-faq/${id}`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching FAQ details for editing:", error);
    throw error;
  }
};

// Update FAQ
export const updateFaq = async (id, faqData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(faqData),
  };

  try {
    const response = await fetch(`${baseUrl}api/update-faq/${id}`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating FAQ:", error);
    throw error;
  }
};

// Delete FAQ
export const trashFaq = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/trash-faq/${id}`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting FAQ:", error);
    throw error;
  }
};

// OPD Schedules

// 1. List OPD Schedule PDFs
export const fetchOpdSchedulePdfs = async () => {
  const token = localStorage.getItem("token");

  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-opd-schedule-pdf`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching OPD schedule PDFs:", error);
    throw error;
  }
};

// 2. Edit a specific OPD Schedule PDF
export const editOpdSchedulePdf = async (id) => {
  const token = localStorage.getItem("token");

  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-opd-schedule-pdf/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error editing OPD schedule PDF:", error);
    throw error;
  }
};

// 3. Update a specific OPD Schedule PDF
export const updateOpdSchedulePdf = async (id, formData) => {
  const token = localStorage.getItem("token");

  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-opd-schedule-pdf/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating OPD schedule PDF:", error);
    throw error;
  }
};

// Add Hospital Tour
export const addHospitalTour = async (formDataPayload) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${baseUrl}api/add-hospital-tour`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formDataPayload,
  });

  return await response.json();
};

// List Hospital Tours
export const fetchHospitalTours = async () => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseUrl}api/list-hospital-tour`, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
  return response.json();
};

// Edit Hospital Tour
export const editHospitalTour = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseUrl}api/edit-hospital-tour/${id}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
  return response.json();
};

// Update Hospital Tour
export const updateHospitalTour = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/update-hospital-tour/${id}`,
    settings
  );
  return response.json();
};

// Trash/Delete
export const trashHospitalTour = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseUrl}api/trash-hospital-tour/${id}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
  return response.json();
};

// International Patient Contact List
export const fetchInternationalPatientContacts = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-international-patient-contact-us`,
    settings
  );
  return await response.json();
};

// Health Checkup Appointments
export const fetchHealthCheckupAppointments = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(`${baseUrl}api/list-appointment`, settings);
  return await response.json();
};

// Subscription List
export const fetchSubscriptionList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(`${baseUrl}api/list-subscription`, settings);
  return await response.json();
};

// Request Callback Appointment List from Doctors Page
export const fetchRequestCallbackList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(`${baseUrl}api/list-request-callback`, settings);
  return await response.json();
};

// GEt International Patient Trusted Healthcare Details Cms

export const fetchTrustedHealthCareDetails = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-international-patient-trusted-healthcare`,
    settings
  );
  return await response.json();
};

// Edit International Patient Trusted healthCare details

export const editTrustedHealthCareDetails = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/edit-international-patient-trusted-healthcare/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Update the trustedHealthCare Data

export const updateTrustedHealthCareDetails = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/update-international-patient-trusted-healthcare/${id}`,
    settings
  );
  return response.json();
};

// Trash trusted HealthCare Details
export const trashTrustedHealthCareDeatils = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/trash-international-patient-trusted-healthcare/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Add International Patient Page Specialty
export const addSpecialtyToInternationalPage = async (formData) => {
  const token = localStorage.getItem("token");

  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: formData,
  };

  const response = await fetch(
    `${baseUrl}api/add-international-patient-page-specialty`,
    settings
  );
  return await response.json();
};

// Fetch international specialites
export const fetchSpecialtyDetails = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-international-patient-page-specialty`,
    settings
  );
  return await response.json();
};

// Edit international specialities
export const editSpecialtyDetails = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/edit-international-patient-page-specialty/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Update international specialities
export const updateSpecialityDetails = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/update-international-patient-page-specialty/${id}`,
    settings
  );
  return response.json();
};

// trash international specialites
export const trashSpecialityDetails = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/trash-international-patient-page-specialty/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Fetch insurance patners
export const fetchinsurancePartners = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-international-insurance-partner`,
    settings
  );
  return await response.json();
};

// Edit Insurance partners

export const editInsurancePartners = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/edit-international-insurance-partne/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// update insurance partners

export const updateinsurancePartness = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/update-international-insurance-partner/${id}`,
    settings
  );
  return response.json();
};

// Trash insurance Partners
export const trashInsurancePartners = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/trash-international-insurance-partner/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Add International Patient Doctors
export const addInternationalDoctors = async (formData) => {
  const token = localStorage.getItem("token");

  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: formData,
  };

  const response = await fetch(
    `${baseUrl}api/add-international-patient-page-doctor`,
    settings
  );
  return await response.json();
};

// Fetch International Patient Doctors

export const fetchInternationalDoctors = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-international-patient-page-doctor`,
    settings
  );
  return await response.json();
};

// Edit international Doctors
export const editInternationalDoctors = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/edit-international-patient-page-doctor/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Update international Doctors
export const updateInternationalDoctors = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/update-international-patient-page-doctor/${id}`,
    settings
  );
  return response.json();
};

// trash international Doctors
export const trashInternationalDoctors = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/trash-international-patient-page-doctor/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Add  International Insurance partners
export const addInternationalInsurance = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  const response = await fetch(
    `${baseUrl}api/add-international-insurance-partner`,
    settings
  );
  return await response.json();
};

// List International Insurance partners
export const fetchInternationalInsurance = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-international-insurance-partner`,
    settings
  );
  return await response.json();
};

// Edit international Insurance partners
export const editInternationalInsurance = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/edit-international-insurance-partner/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Update International Insurance Partners

export const updateInternationalInsurance = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/update-international-insurance-partner/${id}`,
    settings
  );
  return response.json();
};

// Trash International Insurance
export const trashInternationalInsurance = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/trash-international-insurance-partner/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Add international statics Card Details
export const addInternationalStatics = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  const response = await fetch(
    `${baseUrl}api/add-international-patient-page-facility`,
    settings
  );
  return await response.json();
};

// List International Statics Card details
export const fetchInternationalStatics = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-international-patient-page-facility`,
    settings
  );
  return await response.json();
};

// Edit International Statics Card Details
export const editInternationalStatics = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/edit-international-patient-page-facility/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Update international statics
export const updateInternationalStatics = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/update-international-patient-page-facility/${id}`,
    settings
  );
  return response.json();
};

// Trash International Statics
export const trashInternationalStatics = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/trash-international-patient-page-facility/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Add International Patient  Why Choose Us
export const addInternationalWhyChooseus = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  const response = await fetch(
    `${baseUrl}api/add-international-patient-page-why-choose-us`,
    settings
  );
  return await response.json();
};

// Fetch International Patient whyChooseUs

export const fetchInternationalWhyChooseus = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-international-patient-page-why-choose-us`,
    settings
  );
  return await response.json();
};

// Edit Inertnational Patient WhyChooseus
export const editInternationalWhyChooseus = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/edit-international-patient-page-why-choose-us/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Update International Patient WhyChooseus
export const updateInternationalWhyChooseus = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/update-international-patient-page-why-choose-us/${id}`,
    settings
  );
  return response.json();
};

// Trash International  Patients WhyChooseus

export const trashInternationalWhyChooseus = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/trash-international-patient-page-why-choose-us/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Add International Our Services Category

export const addInternationalOurServicesCategory = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  const response = await fetch(
    `${baseUrl}api/add-international-patient-services-category`,
    settings
  );
  return await response.json();
};

// fetch International Our Services Category

export const fetchInternationalOurServicesCategory = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-international-patient-services-category`,
    settings
  );
  return await response.json();
};

// Edit International Our Services Category

export const editInternationalOurServicesCategory = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/edit-international-patient-services-category/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Update International Our Services Category
export const updateInternationalOurServicesCategory = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/update-international-patient-services-category/${id}`,
    settings
  );
  return response.json();
};

// Trash International Our Services Category

export const trashInternationalOurServicesCategory = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/trash-international-patient-services-category${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Add International Our Services Details

export const addInternationalOurServicesDetails = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  const response = await fetch(
    `${baseUrl}api/add-international-patient-services-details`,
    settings
  );
  return await response.json();
};

// fetch International Our Services

export const fetchInternationalOurServicesDetails = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-international-patient-services-details`,
    settings
  );
  return await response.json();
};

// Edit International Our Services

export const editInternationalOurServicesDetails = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/edit-international-patient-services-details/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Update International Our Services
export const updateInternationalOurServicesDetails = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      // "Content-Type": "application/json",
    },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/update-international-patient-services-details/${id}`,
    settings
  );
  return response.json();
};

// Trash International Our Services

export const trashInternationalOurServicesDetails = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/trash-international-patient-services-details/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return response.json();
};

// Pages Seo Data Cms Api

export const AddSeoTags = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  const response = await fetch(
    `${baseUrl}api/add-page-seoapi/add-page-seo`,
    settings
  );
  return await response.json();
};

// Fetch Seo Tags
export const fetchSeoTags = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(`${baseUrl}api/list-page-seo`, settings);
  return await response.json();
};
// Edit Seo Tags
export const editSeoTags = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseUrl}api/edit-page-seo/${id}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
  return response.json();
};

// Update Seo Tags
export const updateSeoTags = async (id, formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  const response = await fetch(`${baseUrl}api/update-page-seo/${id}`, settings);
  return response.json();
};

// Trash Seo Tags
export const trashSeoTags = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseUrl}api/trash-page-seo/${id}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  });
  return response.json();
};

// HHomepage Sections Dynamic

// Fetch Home Card List
export const fetchHomeCards = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/list-home-card`, settings);
    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching Home Cards:", error);
    throw error;
  }
};

// Edit Home Card
export const editHomeCard = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-home-card/${id}`,
      settings
    );
    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error editing Home Card:", error);
    throw error;
  }
};

// Update Home Card
export const updateHomeCard = async (id, formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-home-card/${id}`,
      settings
    );
    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Error updating Home Card:", error);
    throw error;
  }
};

// Fetch all homepage doctors
export const fetchHomePageDoctors = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const res = await fetch(`${baseUrl}api/list-home-page-doctors`, settings);
  return await res.json();
};

// Add homepage doctor
export const addHomePageDoctor = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const res = await fetch(`${baseUrl}api/add-home-page-doctors`, settings);
  return await res.json();
};

// Edit homepage doctor
export const editHomePageDoctor = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const res = await fetch(
    `${baseUrl}api/edit-home-page-doctors/${id}`,
    settings
  );
  return await res.json();
};

// Update homepage doctor
export const updateHomePageDoctor = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const res = await fetch(
    `${baseUrl}api/update-home-page-doctors/${id}`,
    settings
  );
  return await res.json();
};

// Trash homepage doctor
export const trashHomePageDoctor = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const res = await fetch(
    `${baseUrl}api/trash-home-page-doctors/${id}`,
    settings
  );
  return await res.json();
};

// Fetch Homepage Specialties
export const fetchHomePageSpecialties = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-home-page-specialty-list`,
      settings
    );
    if (!response.ok) throw new Error("Failed to fetch homepage specialties");
    return await response.json();
  } catch (error) {
    console.error("Error fetching homepage specialties:", error);
    throw error;
  }
};

// Add HomePage Specialty
export const addHomePageSpecialty = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-home-page-specialty`,
      settings
    );
    if (!response.ok) throw new Error("Failed to add specialty");
    return await response.json();
  } catch (error) {
    console.error("Error adding homepage specialty:", error);
    throw error;
  }
};

// Edit HomePage Specialty
export const editHomePageSpecialty = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-home-page-specialty/${id}`,
      settings
    );
    if (!response.ok) throw new Error("Failed to fetch specialty");
    return await response.json();
  } catch (error) {
    console.error("Error editing homepage specialty:", error);
    throw error;
  }
};

// Update HomePage Specialty
export const updateHomePageSpecialty = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-home-page-specialty/${id}`,
      settings
    );
    if (!response.ok) throw new Error("Failed to update specialty");
    return await response.json();
  } catch (error) {
    console.error("Error updating homepage specialty:", error);
    throw error;
  }
};

// Trash HomePage Specialty
export const trashHomePageSpecialty = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-home-page-specialty/${id}`,
      settings
    );
    if (!response.ok) throw new Error("Failed to delete specialty");
    return await response.json();
  } catch (error) {
    console.error("Error trashing homepage specialty:", error);
    throw error;
  }
};

// Fetch Corporate Logos List
export const fetchCorporateLogos = async () => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/fetch-home-page-coporate-logo-list`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
  return await response.json();
};

// Add Corporate Logo
export const addCorporateLogo = async (formData) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseUrl}api/add-home-page-coporate-logo`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
  return await response.json();
};

// Edit Corporate Logo
export const editCorporateLogo = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/edit-home-page-coporate-logo/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return await response.json();
};

// Update Corporate Logo
export const updateCorporateLogo = async (id, formData) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/update-home-page-coporate-logo/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    }
  );
  return await response.json();
};

// Trash Corporate Logo
export const trashCorporateLogo = async (id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(
    `${baseUrl}api/trash-home-page-coporate-logo/${id}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    }
  );
  return await response.json();
};

// Fetch TPA Logos
export const fetchTpaLogos = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${baseUrl}api/list-home-page-tpa-logo`,
    settings
  );
  return await response.json();
};

// Add TPA Logo
export const addTpaLogo = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/add-home-page-tpa-logo`,
    settings
  );
  return await response.json();
};

// Edit TPA Logo
export const editTpaLogo = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  const response = await fetch(
    `${baseUrl}api/edit-home-page-tpa-logo/${id}`,
    settings
  );
  return await response.json();
};

// Update TPA Logo
export const updateTpaLogo = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: data,
  };

  const response = await fetch(
    `${baseUrl}api/update-home-page-tpa-logo/${id}`,
    settings
  );
  return await response.json();
};

// Trash TPA Logo
export const trashTpaLogo = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  const response = await fetch(
    `${baseUrl}api/trash-home-page-tpa-logo/${id}`,
    settings
  );
  return await response.json();
};

// Fetch Home About S.L. Raheja
export const fetchHomeAboutSLRaheja = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-home-page-about-slraheja`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Home About S.L. Raheja:", error);
    throw error;
  }
};

// Edit Home About S.L. Raheja
export const editHomeAboutSLRaheja = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-home-page-about-slraheja/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error editing Home About S.L. Raheja:", error);
    throw error;
  }
};

// Update Home About S.L. Raheja
export const updateHomeAboutSLRaheja = async (id, formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: formData, // Send as multipart/form-data
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-home-page-about-slraheja/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating Home About S.L. Raheja:", error);
    throw error;
  }
};

// Trash Home About S.L. Raheja
export const trashHomeAboutSLRaheja = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-home-page-about-slraheja/${id}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error trashing Home About S.L. Raheja:", error);
    throw error;
  }
};

// Fetch International Banner Features
export const fetchInternationalBannerList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-home-page-international-banner-features`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching international banner features:", error);
    throw error;
  }
};

// Edit International Banner Feature
export const editInternationalBanner = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-home-page-international-banner-features/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error editing international banner:", error);
    throw error;
  }
};

// Update International Banner Feature
export const updateInternationalBanner = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data, // FormData or JSON
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-home-page-international-banner-features/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating international banner:", error);
    throw error;
  }
};

// Trash International Banner Feature
export const trashInternationalBanner = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/trash-home-page-international-banner-features/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error trashing international banner:", error);
    throw error;
  }
};

// Fetch Trashed Doctors
export const fetchTrashedDoctors = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/trash-doctor-list`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching trashed doctors:", error);
    throw error;
  }
};

// Restore Doctor
export const restoreDoctor = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/restore-doctor/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error restoring doctor:", error);
    throw error;
  }
};

const token = localStorage.getItem("token");

export const addEmergencyContact = async (data) => {
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-emergency-contact-number`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error adding emergency contact:", error);
    throw error;
  }
};

export const fetchEmergencyContactList = async () => {
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-emergency-contact-number`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching emergency contact list:", error);
    throw error;
  }
};

export const fetchEmergencyContactDetails = async (id) => {
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/edit-emergency-contact-number/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching emergency contact details:", error);
    throw error;
  }
};

export const updateEmergencyContact = async (id, data) => {
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/update-emergency-contact-number/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error updating emergency contact:", error);
    throw error;
  }
};

// =============================================================
// 1. Advanced Medical Equipment — CATEGORY end-points
// =============================================================

/**
 * POST  /api/add-advanced-medical-equipment-category
 * @param {FormData} data  ─ must include `category_name`
 */
export const addAdvancedMedicalEquipmentCategory = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data, // FormData
  };
  const response = await fetch(
    `${baseUrl}api/add-advanced-medical-equipment-category`,
    settings
  );
  return response.json();
};

/**
 * GET  /api/list-advanced-medical-equipment-category
**/
export const fetchAdvancedMedicalEquipmentCategoryList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-advanced-medical-equipment-category`,
    settings
  );
  return response.json();
};

/**
 * POST  /api/edit-advanced-medical-equipment-category/{id}
 *  – returns the single category for the edit form
 */
export const editAdvancedMedicalEquipmentCategory = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/edit-advanced-medical-equipment-category/${id}`,
    settings
  );
  return response.json();
};

/**
 * POST  /api/update-advanced-medical-equipment-category/{id}
 * @param {FormData} data
 */
export const updateAdvancedMedicalEquipmentCategory = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,
  };
  const response = await fetch(
    `${baseUrl}api/update-advanced-medical-equipment-category/${id}`,
    settings
  );
  return response.json();
};

/**
 * POST  /api/trash-advanced-medical-equipment-category/{id}
 */
export const trashAdvancedMedicalEquipmentCategory = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/trash-advanced-medical-equipment-category/${id}`,
    settings
  );
  return response.json();
};

// =============================================================
// 2. Advanced Medical Equipment — DETAILS end-points
// =============================================================

/**
 * POST  /api/add-advanced-medical-equipment-details
 * @param {FormData} data ─ heading, content, img_path, equipment_category_id
 */
export const addAdvancedMedicalEquipmentDetails = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,
  };
  const response = await fetch(
    `${baseUrl}api/add-advanced-medical-equipment-details`,
    settings
  );
  return response.json();
};

/**
 * GET  /api/list-advanced-medical-equipment-details
 */
export const fetchAdvancedMedicalEquipmentDetailsList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-advanced-medical-equipment-details`,
    settings
  );
  return response.json();
};

/**
 * POST  /api/edit-advanced-medical-equipment-details/{id}
 */
export const editAdvancedMedicalEquipmentDetails = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/edit-advanced-medical-equipment-details/${id}`,
    settings
  );
  return response.json();
};

/**
 * POST  /api/update-advanced-medical-equipment-details/{id}
 * @param {FormData} data
 */
export const updateAdvancedMedicalEquipmentDetails = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,
  };
  const response = await fetch(
    `${baseUrl}api/update-advanced-medical-equipment-details/${id}`,
    settings
  );
  return response.json();
};

/**
 * POST  /api/trash-advanced-medical-equipment-details/{id}
 */
export const trashAdvancedMedicalEquipmentDetails = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/trash-advanced-medical-equipment-details/${id}`,
    settings
  );
  return response.json();
};

// =============================================================
// 3. Hospital Services DETAILS end-points
// =============================================================

/**
 * POST  /api/add-hospital-services-details
 * @param {FormData} data ─ heading, content, img_path
 */
export const addHospitalServicesDetails = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,
  };
  const response = await fetch(
    `${baseUrl}api/add-hospital-services-details`,
    settings
  );
  return response.json();
};

/**
 * GET  /api/list-hospital-services-details
 */
export const fetchHospitalServicesDetailsList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-hospital-services-details`,
    settings
  );
  return response.json();
};

/**
 * POST  /api/edit-hospital-services-details/{id}
 */
export const editHospitalServicesDetails = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/edit-hospital-services-details/${id}`,
    settings
  );
  return response.json();
};

/**
 * POST  /api/update-hospital-services-details/{id}
 * @param {FormData} data
 */
export const updateHospitalServicesDetails = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,
  };
  const response = await fetch(
    `${baseUrl}api/update-hospital-services-details/${id}`,
    settings
  );
  return response.json();
};

/**
 * POST  /api/trash-hospital-services-details/{id}
 */
export const trashHospitalServicesDetails = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/trash-hospital-services-details/${id}`,
    settings
  );
  return response.json();
};

/***************************************************************
 *  HOSPITAL — HOME-CARE SERVICES  (icon_path upload)
 ***************************************************************/

// POST  /api/add-hospital-home-care-services
export const addHospitalHomeCareService = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,                       // ← FormData
  };
  const response = await fetch(
    `${baseUrl}api/add-hospital-home-care-services`,
    settings
  );
  return response.json();
};

// GET  /api/list-hospital-home-care-services
export const fetchHospitalHomeCareServicesList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-hospital-home-care-services`,
    settings
  );
  return response.json();
};

// POST  /api/edit-hospital-home-care-services/{id}
export const editHospitalHomeCareService = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/edit-hospital-home-care-services/${id}`,
    settings
  );
  return response.json();
};

// POST  /api/update-hospital-home-care-services/{id}
export const updateHospitalHomeCareService = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,                       // ← FormData
  };
  const response = await fetch(
    `${baseUrl}api/update-hospital-home-care-services/${id}`,
    settings
  );
  return response.json();
};

// POST /api/trash-hospital-home-care-services/{id}
export const trashHospitalHomeCareService = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/trash-hospital-home-care-services/${id}`,
    settings
  );
  return response.json();
};


/***************************************************************
 *  HOSPITAL — OTHER SERVICES  (img_path upload)
 ***************************************************************/

// POST  /api/add-hospital-other-services
export const addHospitalOtherService = async (data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,                       // ← FormData
  };
  const response = await fetch(
    `${baseUrl}api/add-hospital-other-services`,
    settings
  );
  return response.json();
};

// GET  /api/list-hospital-other-services
export const fetchHospitalOtherServicesList = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/list-hospital-other-services`,
    settings
  );
  return response.json();
};

// POST  /api/edit-hospital-other-services/{id}
export const editHospitalOtherService = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/edit-hospital-other-services/${id}`,
    settings
  );
  return response.json();
};

// POST  /api/update-hospital-other-services/{id}
export const updateHospitalOtherService = async (id, data) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
    body: data,                      // ← FormData
  };
  const response = await fetch(
    `${baseUrl}api/update-hospital-other-services/${id}`,
    settings
  );
  return response.json();
};

// POST  /api/trash-hospital-other-services/{id}
export const trashHospitalOtherService = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/trash-hospital-other-services/${id}`,
    settings
  );
  return response.json();
};


// Dashboard Cards Counts

export const fetchTotalContactListCount = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/total-contact-us-enquiry`,
    settings
  );
  return response.json();
};

export const fetchTotalInternationalListCount = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/total-international-patient-contact-us-enquiry`,
    settings
  );
  return response.json();
};
export const fetchTotalCallbackListCount = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/total-request-callback-enquiry`,
    settings
  );
  return response.json();
};
export const fetchTotalAppointmentEnquiryCount = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/total-appointment-enquiry`,
    settings
  );
  return response.json();
};
export const fetchTotalJobApplicationCount = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    },
  };
  const response = await fetch(
    `${baseUrl}api/total-job-application`,
    settings
  );
  return response.json();
};

export const reorderDoctors = async ({ from_id, to_id }) => {
  const token = localStorage.getItem("token");
  try {
    const response = await fetch(`${baseUrl}api/reorder-doctors`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ from_id, to_id }),
    });
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const reorderSpecialties = async ({ from_id, to_id }) => {
  const token = localStorage.getItem("token");
  try {
    const response = await fetch(`${baseUrl}api/reorder-specialities`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ from_id, to_id }),
    });
    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const fetchSpecialityDoctorList = async (speciality_id) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseUrl}api/list-speciality-doctor`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ speciality_id }),
  });
  return response.json();
};

export const reorderSpecialistDoctors = async ({ from_id, to_position }) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseUrl}api/reorder-specialities-doctor-position`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ from_id, to_position }),
  });
  return response.json();
};

export const toggleDoctorSpecialityStatus = async ({ id, doctor_id, speciality_id, status }) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${baseUrl}api/toggle-doctor-speciality-status`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ id, doctor_id, speciality_id, status }),
  });
  return response.json();
};

export const setDoctorSpecialityPosition = async ({ doctor_specialities_id, display_order }) => {
  const token = localStorage.getItem("token");

  try {
    const response = await fetch(`${baseUrl}api/set-doctor-speciality-position`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ doctor_specialities_id, display_order }),
    });

    return await response.json();
  } catch (error) {
    console.error("Failed to set doctor position:", error);
    throw error;
  }
};

// ✅ Fetch public Bio-Medical Waste Report list
export const fetchPublicBioMedicalWasteReports = async () => {
  const settings = { method: "GET", headers: { Accept: "application/json" } };
  try {
    const res = await fetch(`${baseUrl}api/fetch-bio-medical-waste-report`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error fetching public bio-medical waste reports:", e);
    throw e;
  }
};

// ✅ Filter public Bio-Medical Waste Report list
export const filterBioMedicalWasteReports = async (data) => {
  const settings = {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  try {
    const res = await fetch(`${baseUrl}api/filter-regulatory-complience-detail-list`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error filtering bio-medical waste reports:", e);
    throw e;
  }
};

// ✅ Add Bio-Medical Waste Report CMS
export const addBioMedicalWasteReportCMS = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    body: formData,
  };
  try {
    const res = await fetch(`${baseUrl}api/add-bio-medical-waste-report`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error adding bio-medical waste report:", e);
    throw e;
  }
};

// ✅ List Bio-Medical Waste Report CMS
export const listBioMedicalWasteReportCMS = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
  };
  try {
    const res = await fetch(`${baseUrl}api/list-bio-medical-waste-report`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error listing bio-medical waste reports:", e);
    throw e;
  }
};

// ✅ Edit Bio-Medical Waste Report CMS
export const editBioMedicalWasteReportCMS = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
  };
  try {
    const res = await fetch(`${baseUrl}api/edit-bio-medical-waste-report/${id}`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error editing bio-medical waste report:", e);
    throw e;
  }
};

// ✅ Update Bio-Medical Waste Report CMS
export const updateBioMedicalWasteReportCMS = async (id, formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  };
  try {
    const res = await fetch(`${baseUrl}api/update-bio-medical-waste-report/${id}`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error updating bio-medical waste report:", e);
    throw e;
  }
};

// ✅ Add Or Update Regulatory Compliance Bio Medica Waste Report PDF File Cms
export const addUpdateBmwPdfFileCMS = async (formData) => {
    const token = localStorage.getItem("token");
    const settings = {
        method: "POST",
        // Do not set 'Content-Type' when sending FormData, the browser handles it.
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
    };
    try {
        const res = await fetch(`${baseUrl}api/add-update-bio-medical-waste-report-pdf-file`, settings);
        return await res.json();
    } catch (e) {
        console.content_fetcher_error("Error adding/updating Bio-Medical Waste PDF file:", e);
        throw e;
    }
};

// ✅ Trash Bio-Medical Waste Report CMS
export const trashBioMedicalWasteReportCMS = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
  };
  try {
    const res = await fetch(`${baseUrl}api/trash-bio-medical-waste-report/${id}`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error trashing bio-medical waste report:", e);
    throw e;
  }
};


// ✅ Fetch public Organ Transplant Report list
export const fetchPublicOrganTransplantReports = async () => {
  const settings = { method: "GET", headers: { Accept: "application/json" } };
  try {
    const res = await fetch(`${baseUrl}api/fetch-organ-transplant-report-list`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error fetching organ transplant reports:", e);
    throw e;
  }
};

// ✅ Filter Organ Transplant Report list
export const filterOrganTransplantReports = async (data) => {
  const settings = {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  try {
    const res = await fetch(`${baseUrl}api/filter-organ-transplant-report-list`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error filtering organ transplant reports:", e);
    throw e;
  }
};

// ✅ Add Organ Transplant Report CMS
export const addOrganTransplantReportCMS = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    body: formData,
  };
  try {
    const res = await fetch(`${baseUrl}api/add-organ-transplant-report`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error adding organ transplant report:", e);
    throw e;
  }
};

// ✅ List Organ Transplant Report CMS
export const listOrganTransplantReportCMS = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
  };
  try {
    const res = await fetch(`${baseUrl}api/list-organ-transplant-report`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error listing organ transplant reports:", e);
    throw e;
  }
};

// ✅ Edit Organ Transplant Report CMS
export const editOrganTransplantReportCMS = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
  };
  try {
    const res = await fetch(`${baseUrl}api/edit-organ-transplant-report/${id}`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error editing organ transplant report:", e);
    throw e;
  }
};

// ✅ Update Organ Transplant Report CMS
export const updateOrganTransplantReportCMS = async (id, formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  };
  try {
    const res = await fetch(`${baseUrl}api/update-organ-transplant-report/${id}`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error updating organ transplant report:", e);
    throw e;
  }
};

// ✅ Trash Organ Transplant Report CMS
export const trashOrganTransplantReportCMS = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
  };
  try {
    const res = await fetch(`${baseUrl}api/trash-organ-transplant-report/${id}`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error trashing organ transplant report:", e);
    throw e;
  }
};


// ✅ Add Organ Transplant Committee CMS
export const addOrganTransplantCommitteeCMS = async (formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    body: formData,
  };
  try {
    const res = await fetch(`${baseUrl}api/add-organ-transplant-committee`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error adding organ transplant committee record:", e);
    throw e;
  }
};

// ✅ List Organ Transplant Committee CMS
export const listOrganTransplantCommitteeCMS = async () => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "GET",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
  };
  try {
    const res = await fetch(`${baseUrl}api/list-organ-transplant-committee`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error listing organ transplant committee records:", e);
    throw e;
  }
};

// ✅ Edit Organ Transplant Committee CMS
export const editOrganTransplantCommitteeCMS = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
  };
  try {
    const res = await fetch(`${baseUrl}api/edit-organ-transplant-committee/${id}`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error editing organ transplant committee record:", e);
    throw e;
  }
};

// ✅ Update Organ Transplant Committee CMS
export const updateOrganTransplantCommitteeCMS = async (id, formData) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    body: formData,
  };
  try {
    const res = await fetch(`${baseUrl}api/update-organ-transplant-committee/${id}`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error updating organ transplant committee record:", e);
    throw e;
  }
};

// ✅ Trash Organ Transplant Committee CMS
export const trashOrganTransplantCommitteeCMS = async (id) => {
  const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
  };
  try {
    const res = await fetch(`${baseUrl}api/trash-organ-transplant-committee/${id}`, settings);
    return await res.json();
  } catch (e) {
    console.error("Error trashing organ transplant committee record:", e);
    throw e;
  }
};
